
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.4","d":"M15.041 1.6a13.19 13.19 0 0 1 13.144 13.44c.1 2.474-.5 4.926-1.73 7.074L30.4 30.4l-8.288-3.948A13.433 13.433 0 1 1 15.042 1.6zm.159 23.2a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8zM12.8 7.2h4.8l-1.44 10.4h-1.92L12.8 7.2z","vector-effect":"non-scaling-stroke"}})])
          )
        }
      }
    